import { TextField } from "@mui/material";
import styles from "./AddNewProject.module.css";
import { useEffect, useState } from "react";
import store from "../../../Store/Store";
import axios from "axios";
import config from "../../../config/config";
import { verifyTokenAccess } from "../../../Helper";

const AddNewProject = ({ isVisible, setClose, Edit, NewCategoryAdded }) => {
  const [ErrorMessage, setErrorMessage] = useState("");
  const [ProjectName, setCategoryName] = useState("");
  const [Description, setDescription] = useState("");
  const [errormsg, setErrorMsg] = useState({
    InValidCatname: false,
    categoryLength: false,
    InvalidDescription: false,
    DescriptionLength: false,
  });
  useEffect(() => {
    console.log("store.Company_Id", store.Company_Id);
  });
  const onFrameButtonClick = async () => {
    console.log("new ProjectCreated");
    
    // ====================TEST====================
        setClose();
        NewCategoryAdded();

    if (ProjectName.trim().length < 1) {
      console.log("this is no category");
      //Error Message
      setErrorMessage("Category Name Field cannot be empty.");
      setErrorMsg((prev) => ({ ...prev, InValidCatname: true }));

      return;
    }
    if (errormsg.InValidCatname) {
      return;
    }
    if (ProjectName.trim().length > 100) {
      console.log("this is Invalid category");
      //Error Message
      return;
    }
    if (Description.trim().length > 100) {
      console.log("this is Invalid Description");
      //Error Message
      return;
    }
    if (Description.trim().length > 100) {
      console.log("this is Invalid Description");
      //Error Message
      return;
    }

    let tokens = localStorage.getItem("authToken");
    await verifyTokenAccess("NewProject FRAME CLICKED")
    let parsedTokens = JSON.parse(tokens);
    console.log("CLICKED");
    let obj = {
      project_name: ProjectName, //max_length 100 character, Special Characters allowed: - _ / ( ) Space
      project_description: Description, //max_length 100 charachter //All special characters Should be allowed
      ledger_label: store.Company_Id,
    };

    let payload = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${config.node_api_endpoint}/cupi/admin/create_project_tag`,
      headers: {
        aws_cognito_id_token: parsedTokens.IdToken,
        aws_cognito_access_token: parsedTokens.AccessToken,
        "Content-Type": "application/json",
      },
      data: obj,
    };
    axios
      .request(payload)
      .then(() => {
        setClose();
        NewCategoryAdded();
      })
      .catch((err) => {
        console.log("error %o", err);
        const errorBody = err?.response?.data?.data;

        if (
          typeof errorBody === "string" &&
          errorBody.startsWith("Category Already Exists :")
        ) {
          // → this is the "category already exists" error
          setErrorMessage("This Category already Exists.");
          setErrorMsg((prev) => ({
            ...prev,
            InValidCatname: true,
          }));
          console.log("Category already exists!==============");
        }
      });
  };

  const OnProjectupdate =async ()=>{
console.log("Project Updated");
        setClose();
        NewCategoryAdded();

  }

  if (!isVisible) return null;
  return (
    <div
      className={[styles.frameParent].join(" ")}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div
        className={styles.frameGroup}
        onClick={() => {
          setClose();
        }}
      >
        <img className={styles.arrowNarrowLeftIcon} alt="" src="/xclose.svg" />
      </div>
      <div className={styles.frameParent1}>
        {Edit ? (
          <div className={styles.frameHeading}>Add New Project</div>
        ) : (
          <div className={styles.frameHeading}>Edit Project</div>
        )}
        <div className={styles.frameWrapper}>
          <div className={styles.mobileMenuParent}>
            <div className={styles.mobileMenuParent}>
              {Edit ? (
                <div className={styles.ProjectNameContainer}>
                  <div className={styles.ProjectNameTitle}>PROJECT NAME</div>
                  <div className={styles.ProjectNameBody}>
                    B2B Invoice management system promotion
                  </div>
                </div>
              ) : (
                <div>
                  <TextField
                    className={styles.mobileMenu}
                    color="primary"
                    value={ProjectName}
                    label="Enter Project Name"
                    required
                    onChange={(e) => {
                      const newValue = e.target.value;

                      setErrorMessage("");
                      setErrorMsg((prev) => ({
                        ...prev,
                        InValidCatname: false,
                      }));

                      // Allow empty string + allow shortening (deletion)
                      if (
                        newValue === "" ||
                        newValue.length < ProjectName.length
                      ) {
                        setCategoryName(newValue);
                        return;
                      }

                      // From here: only new characters / longer input
                      if (newValue.length > 100) {
                        setErrorMessage("Maximum 100 characters allowed");
                        setErrorMsg((prev) => ({
                          ...prev,
                          InValidCatname: true,
                        }));
                        return;
                      }

                      setCategoryName(newValue);
                      const regex = /^[a-zA-Z0-9\-_()\/ ]+$/;
                      if (!regex.test(newValue)) {
                        setErrorMessage(
                          "Category Name cannot contain this special character.",
                        );
                        setErrorMsg((prev) => ({
                          ...prev,
                          InValidCatname: true,
                        }));
                        return;
                      }

                      if (newValue.length >= 100) {
                        setErrorMessage("Maximum Character Length Reached");
                        setErrorMsg((prev) => ({
                          ...prev,
                          categoryLength: true,
                        }));
                        return;
                      } else {
                        setErrorMsg((prev) => ({
                          ...prev,
                          categoryLength: false,
                        }));
                      }
                    }}
                    variant="outlined"
                    inputProps={{ maxLength: 100 }}
                    sx={{
                      width: "100%",
                      "& .MuiInputBase-root": { minHeight: "56px" },
                    }}
                    InputProps={{
                      style: { borderRadius: ".45rem" },
                    }}
                  />

                  {errormsg.InValidCatname && (
                    <div className={styles.errorDiv}>
                      <div className={styles.error}>{ErrorMessage}</div>
                    </div>
                  )}
                  {errormsg.categoryLength && (
                    <div className={styles.errorDiv}>
                      <div className={styles.error}>{ErrorMessage}</div>
                    </div>
                  )}
                </div>
              )}

              <div>
                <TextField
                  className={styles.mobileMenu}
                  color="primary"
                  value={Description}
                  label="Enter Description"
                  onChange={(e) => {
                    const value = e.target.value;

                    // Clear previous errors
                    setErrorMessage("");
                    setErrorMsg((prev) => ({
                      ...prev,
                      InvalidDescription: false,
                      // ... other flags you want to clear
                    }));

                    if (value.length >= 100) {
                      setErrorMessage("Maximum 100 characters allowed");
                      setErrorMsg((prev) => ({
                        ...prev,
                        InvalidDescription: true,
                      }));
                      return;
                    }

                    setDescription(value);
                  }}
                  variant="outlined"
                  inputProps={{ maxLength: 100 }}
                  sx={{
                    width: "100%",
                    "& .MuiInputBase-root": { minHeight: "56px" },
                  }}
                  InputProps={{
                    style: { borderRadius: ".45rem" },
                  }}
                />

                {errormsg.InvalidDescription && (
                  <div className={styles.errorDiv}>
                    <div className={styles.error}>{ErrorMessage}</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.GreayedText}>
          Note: Once this project is added, you cannot edit the project name or
          remove it. However, you can disable it at any time.
        </div>
        <div
          className={styles.frameDiv}
          onClick={async () => {
            // await onFrameButtonClick();
             Edit?OnProjectupdate(): onFrameButtonClick()
            // await new Promise(resolve => setTimeout(resolve, 1000));
          }}
        >
          <div className={styles.loadsButtonsWrapper}>
            <div className={styles.loadsButtons} onClick={()=>{
           
            }}>
              <b className={styles.submit}>Submit</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AddNewProject;
